module.exports = __webpack_public_path__ + "img/project_background2.cf38a13d.jpeg";